import { observer, useLocalStore } from 'mobx-react';
import * as React from 'react';
import { mg } from '../../../mg/mg';
import { MgColumnExtras, mgColumnFactory, MgColumnist } from '../../../mg/table/MgColumn';
import { MgEntityEditDialog } from '../../../mg/table/MgEntityEditDialog';
import { Momentino } from '../../../services/Momentino';
import { toasterSvc } from '../../../services/ToasterSvc';
import { IMultirepo } from '../../../stores/Multirepo';
import { useOmnistore } from '../../../stores/Omnistore';

const columnist = mgColumnFactory.createColumnist([
	'*supplierId =advertizer',
	'*name',
	'*validSince :datetime',
	'*validUntil :datetime',

	null,
	'*variationsBase :variationsBase',
	'variationsMore :variationsMore',
	'*imageLink :imageLink',
	'*description',

	null,
	'badgeTitle',
	'badgeSubtitle',
	'*badgeColor :color',
	'amountStep :posInt',
	'amountMax :nonNegInt',
	'oncePerBranch :bool',
	'viaTemplate :bool',
	'nInitialItems :nonNegInt',
	'*supplierIdsAsString :idsAsString',
]);

function extrasFn(columnist: MgColumnist, entity: any, multirepo: IMultirepo) : Record<string, MgColumnExtras> {
	const isUpdate = !!entity.id;
	return columnist.newExtras(entity, {
		supplierId: {
			members: multirepo.masterSupplierRepo.allAsList.map(s => ({ id: s.id, text: s.name })).sort(mg.comparatorOn(e => e.text)),
		},
		validSince: {
			min: isUpdate ? undefined : Momentino.millisTo.timestampWithMillis(Date.now()),
		},
		validUntil: {
			min: entity.validSince,
		},
		variationsBase: {
			errorText: entity.variationsBase.length!==1 || !entity.variationsBase[0].id || !entity.variationsBase[0].name,
		},
		variationsMore: {
			errorText: (() => {
				const base: Array<{id: number, name: string}> = entity.variationsBase;
				const more: Array<{id: number, name: string}> = entity.variationsMore;
				if (more.some(v => !v.id || !v.name)) return 'emptyVariation';
				const list = [...base, ...more];
				const set = new Set(list.map(v => v.id));
				if (set.size !== list.length) return 'duplicatedVariation';
				return false;
			})(),
		},
		supplierIdsAsString: {
			members: multirepo.publicSupplierRepo.allAsList.map(s => ({ id: s.id, text: s.name })).sort(mg.comparatorOn(e => e.text)),
		},
		badgeSubtitle: {
			hidden: !entity.badgeTitle,
		},
		badgeColor: {
			hidden: !entity.badgeTitle,
		},
	});
}

interface IAdmAdDialogProps {
	entity?: object
	onClose() : void
}

export const AdmAdDialog = observer(function AdmAdDialog(props: IAdmAdDialogProps) {
	const entity = useLocalStore(() => {
		const e = columnist.newEntity(props.entity) as Record<string, any>;
		e.variationsBase = e.variations?.slice(0, 1) || [{id: 0, name: ''}];
		e.variationsMore = e.variations?.slice(1) || [];
		e.category = e.category ?? 'NONE';
		return e;
	});
	const omnistore = useOmnistore();
	const multirepo = omnistore.multirepo;
	function finish(entity: Record<string, any>) : void {
		if (!entity) return props.onClose();
		const {variationsBase, variationsMore, ...rest} = entity;
		const variations: Array<{id: number, name: string}> = variationsBase.concat(variationsMore);
		entity = {...rest, variations};
		omnistore.communicator.doPost('PutAdvertisement', entity)
			.then(toasterSvc.handleResponse('saved'))
			.then(r => {
				if (r.outputObject) {
					multirepo.admAdRepo.fetch('DIRECT');
					props.onClose();
				}
			});
	}
	return <MgEntityEditDialog
		columnist={columnist}
		extras={extrasFn(columnist, entity, multirepo)}
		entity={entity}
		baseName="AdmAdDialog"
		finish={finish}
	/>;
});
